module.exports = __webpack_public_path__ + "static/app-preview-10aa3a66c3bcbaab4af15072323b7949.webp";